import SectionLabel from "../common/SectionLabel";
import OtherProjectRow from "./OtherProjectRow";
import { otherProjects } from "../../data/otherProjects";

function OtherProjects() {
  return (
    <section className="divider">
      <div className="wrap">
        <SectionLabel label="other projects" />
        <div className="other-list">
          {otherProjects.map((project) => (
            <OtherProjectRow project={project} key={project.slug} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default OtherProjects;
